var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.66 4.345a7.968 7.968 0 0 0-6.33-2.318c-3.212.258-6.026 2.49-6.968 5.571-.673 2.201-.39 4.5.705 6.397L2.03 17.442c-.099.33.203.642.537.553l3.607-.966a7.994 7.994 0 0 0 3.823.973H10c3.36 0 6.464-2.055 7.538-5.238 1.046-3.105.272-6.266-1.878-8.42zm-1.746 8.51c-.166.468-.982.918-1.35.95-.366.034-.71.166-2.398-.5-2.032-.8-3.315-2.883-3.414-3.016-.1-.134-.816-1.084-.816-2.068 0-.983.516-1.467.7-1.666.183-.2.4-.25.533-.25s.267 0 .383.005c.142.005.3.012.45.345.178.395.566 1.384.616 1.484.05.1.083.217.017.35-.067.133-.1.216-.2.333-.1.117-.21.26-.3.35-.1.1-.204.208-.087.408.117.2.517.854 1.111 1.384.764.68 1.408.891 1.608.992.2.1.316.083.433-.05.117-.133.5-.583.633-.784.133-.2.267-.166.45-.1.183.067 1.166.55 1.366.65.2.1.333.15.382.234.05.082.05.483-.117.95z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsApp);
export default __webpack_public_path__ + "static/media/whats-app.8eb16461dd9c1cfa5d7e094cbc415e53.svg";
export { ForwardRef as ReactComponent };